/**
 * 运维团队模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/safeGroup/*
 *
 * 迁移自前端原接口（rest_client.js / setting_action.js）：
 *   getSafeGroupList -> /rest/security/safegroup/list
 *   （运维团队 CRUD 旧接口无完整对应，本次按 doc/04A 新接口对接）
 *
 * 运维团队 = SecurityGroup（groupId=团队 ID，description=团队名）。
 * 兼容前端 getSafeGroupList 的 data.groups 结构：{ Id, Name }。
 */
import { ofbiz } from './http';

/**
 * 运维团队列表（替代旧 getSafeGroupList）
 * @returns {Promise<Array>} [{ Id, Name }]
 */
export function getSafeGroupList() {
  return ofbiz.post('safeGroup/list').then(data => {
    // 兼容两种返回：{ groups: [...] }（兼容旧字段）或 { list: [...] }
    if (data && Array.isArray(data.groups)) return data.groups;
    const list = (data && data.list) || (Array.isArray(data) ? data : []);
    return list.map(item => ({
      Id: item.Id || item.groupId || item.teamId,
      Name: item.Name || item.groupName || item.teamName || item.description || '',
    }));
  });
}

/**
 * 新增运维团队
 * @param {string} teamId 团队 ID（= SecurityGroup.groupId）
 * @param {string} teamName 团队名称
 * @returns {Promise<object>}
 */
export function createSafeGroup(teamId, teamName) {
  return ofbiz.post('safeGroup/create', { teamId, teamName });
}

/**
 * 删除运维团队
 * @param {string} teamId
 * @returns {Promise<object>}
 */
export function deleteSafeGroup(teamId) {
  return ofbiz.post('safeGroup/delete', null, { teamId });
}
